"use client"

import React from "react";
import styles from "../../styles/Pages/IllusionMuseum.module.scss";
import Image from "next/image";
import { AncorSecoundaryButton } from "../../components/Reusable/Buttons/Buttons";
import Link from "next/link";
import Accordion from "../../components/Reusable/Accordion/Accordion";
import MuseumofMystiqueFaq from "../../components/Schema/GroupSchema/MuseumofMystiqueFaq";
import MuseumofMystiqueBreadcrumb from "../../components/Schema/GroupSchema/MuseumofMystiqueBreadcrumb";

const MuseumMystique = () => {
  const experienceData = [
    {
      id: 1,
      title: "3D Camouflage Room",
      description:
        "A 3D Camouflage Room is a creatively designed space that uses camouflage-inspired patterns, textures, and optical illusions to blend surfaces seamlessly and create a sense of depth.",
      image: "/images/museum/activity-1.png",
    },
    {
      id: 2,
      title: "Interactive Optical Illusions",
      description:
        "This zone is made for play! Wave your hands, clap, or just move around and watch the illusions react. They shift, change, and dance with you.  ",
      image: "/images/museum/activity-10.png",
    },
    {
      id: 3,
      title: "Ames Room",
      description:
        "In an Ames room, one side shrinks you, and the other turns you into a giant. Bring your tall friends to see them just looking up to you!",
      image: "/images/museum/activity-8.png",
    },
    {
      id: 4,
      title: "Head on a Plate",
      description:
        "Sit on a table and become a floating head on a plate. Yes, this illusion makes your head look like it’s served on a platter. ",
      image: "/images/museum/activity-5.png",
    },
    {
      id: 5,
      title: "Impossible Chair ",
      description:
        "Sit down and confuse everyone! This chair makes it look like your legs are on the wrong side or you're floating in mid-air.  ",
      image: "/images/museum/activity-3.png",
    },
    {
      id: 6,
      title: "Reverse Room",
      description:
        "Dreamed of walking on a ceiling? Well, in our upside-down room, you can even dance, jump, and lie on the ceiling and ask Newton, “Gravity, who?” ",
      image: "/images/museum/activity-9.png",
    },
    {
      id: 7,
      title: "Infinity Room  ",
      description:
        "Say hi to a thousand versions of yourself! Mirrors bounce light and reflections in every direction, and suddenly you’re in a world that feels endless. ",
      image: "/images/museum/activity-7.png",
    },
    {
      id: 8,
      title: "Magic Box ",
      description:
        "A mysterious little box that’s full of surprises. Peek inside, turn a knob, or open a flap, and something unexpected always happens.",
      image: "/images/museum/activity-4.png",
    },
  ];
  const diningFaqs = [
    {
      id: 1,
      title: "Do I need to book tickets in advance? ",
      content:
        "Online booking is helpful, especially during weekends or peak tourist days, but it's not required. You can also buy tickets at the counter, depending on availability when you arrive.",
    },
    {
      id: 2,
      title: "Is it just for kids, or will adults enjoy it too?",
      content:
        "The experience is fun for all age groups. While kids love the playfulness, adults often find the illusions just as fascinating and end up clicking as many photos as the kids do.",
    },
    {
      id: 3,
      title: "Is there anything that moves suddenly or could startle someone? ",
      content:
        "Nope! All exhibits are safe, still, and easy-going. There are no sudden movements, loud sounds, or anything designed to scare or startle visitors. It is just optical fun and visual surprises. ",
    },
  ];

  return (
    <>
      <div className={styles.museum_page}>
        <section className={styles.gradient_sec}>
          <div className="container">
            <div className={styles.content_sec}>
              {" "}
              <div className={styles.headings_sec_data}>
                {" "}
                <h1 className="d-none">Museum of Mystique</h1>
                <h2>Step Into The Impossible</h2>
                <p>
                  Experience mind-bending illusions and thrilling adventures
                  that challenge reality.{" "}
                </p>{" "}
                <div className={styles.button_sec}>
                  <Link href="/tickets" className={styles.ticket_btn}>
                    BUY TICKETS
                  </Link>
                  <a href="#activities" className="ananta_btn">
                    EXPLORE ACTIVITIES
                  </a>
                </div>
              </div>
              <div className={styles.image_sec}>
                {" "}
                <Image
                  src="/images/museum/museum-banner.png"
                  alt="banner image"
                  fill={true}
                  style={{ objectFit: "contain" }}
                />{" "}
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className={styles.museum_mystique_sec}>
              <div className={styles.img_sec}>
                <Image
                  src="/images/museum/museum-of-mystique.png"
                  alt="museum-of-mystique"
                  fill={true}
                  sizes="(max-width: 767px) 100vw, 50vw"
                />
              </div>
              <h3>Museum of Mystique </h3>
              <p>
                Museum of Mystique is an optical illusion museum in Adventure
                Resorts, surrounded by the hills of Kufri, Shimla. It’s a place
                where nothing is quite what it seems. Every step you take will
                surprise you and make you question reality.
              </p>
              <p>
                Do you think you’re seeing clearly? Just wait till the walls
                seem to move, rooms bend, and your sense of direction takes a
                playful spin. One moment you’re sure of the ground beneath you…
                the next, it feels like the whole place is alive.{" "}
              </p>
              <p>
                Walk in, let your senses explore, and enjoy a space where
                illusions lead the way.{" "}
              </p>
            </div>
          </div>
        </section>
        <section className={styles.experience_sec} id="activities">
          <div className="container">
            <h3>Unforgettable Experiences</h3>
            <div className={styles.line}></div>
            <p>
              Each activity is designed to challenge your senses and create
              memories that last a lifetime
            </p>
            <div className={styles.flex_row}>
              {experienceData?.map((item, i) => (
                <div className={styles.card} key={i}>
                  <div className={styles.img_sec}>
                    {" "}
                    <Image
                      src={item?.image}
                      alt="activity images"
                      sizes="(max-width: 767px) 100vw, 50vw"
                      fill={true}
                    />
                  </div>
                  <div className={styles.content_sec}>
                    <h4>{item?.title}</h4>
                    <span>{item?.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className={styles.flex_row_data_sec}>
              <div className={styles.content_div}>
                <h3>Turn Group Outings into Unique Adventure</h3>
                <div className={styles.line}></div>

                <p>
                  Museum of Mystique is one of the most unique spaces that you
                  will find in Kufri, filled with optical illusions, playful
                  exhibits, and interactive rooms designed for groups of all
                  kinds to laugh, explore, and bond over mind-bending illusions.
                  Each and every zone that we have is built to shift your
                  perspective and bring out your inner child. Together you all
                  can navigate visual puzzles, tricky reflections, and illusions
                  that will surely surprise you.
                </p>
                <p>
                  Set in the peaceful hills of Kufri, we welcome your group into
                  this illusionistic Museum of Mystique{" "}
                </p>
              </div>
              <div className={styles.img_div}>
                <Image
                  src="/images/museum/activity-8.png"
                  alt="activity images"
                  fill={true}
                  sizes="(max-width: 767px) 100vw , 50vw"
                />
              </div>
            </div>
          </div>
        </section>
        <section className={styles.linear_gradient_sec}>
          <div className="container">
            <div className={styles.linear_gradient_sec_data}>
              <div>
                <h3>See the Impossible, Believe the Unbelievable</h3>
                <p>
                  Experience mind-bending illusions and thrilling adventures
                  that challenge reality.{" "}
                </p>
              </div>
              <Link href="/tickets" className={styles.ticket_btn}>
                BUY TICKETS
              </Link>
            </div>
          </div>
        </section>
        <section className="common_padding">
          <div className="container ">
            <div className={styles.faqs_heading_sec}>
              {" "}
              <h3>FAQs</h3>
              <div className={styles.line}></div>
            </div>

            <div className="row justify-content-center">
              <div className="accordion_parent col-md-8">
                <Accordion items={diningFaqs} />
              </div>
            </div>
          </div>
        </section>

        <MuseumofMystiqueFaq />
        <MuseumofMystiqueBreadcrumb />
      </div>
    </>
  );
};

export default MuseumMystique;
